import TableCell from "../common/table/tableCell";
import TableCellInformation from "../common/table/tableCellInformation";
import TableCellTag from "../common/table/tableCellTag";
import TableCellDate from "../common/table/tableCellDate";
import TableCellTime from "../common/table/tableCellTime";
import ButtonIcon from "../common/buttonIcon";
import { useState } from "react";
import AlertMessageModal from "../alertMessageModal";
import { t } from "i18next";
import { useAppDispatch } from "../../redux";
import {
  deleteDoctorPrenotationStore,
  deletePrenotationStore,
} from "../../redux/reducer/prenotationReducer";
import DropdownIcon from "../common/dropdownIcon";
import { HttpService } from "../../services/HttpService";
import { useSelector } from "react-redux";
import _ from "lodash";

import { getBadgeLabel, hasModules } from "../../utils/helpers";

const PrenotationRow = (props: any) => {
  let prenotation =
    props.prenotation && props.prenotation.length ? props.prenotation : [];
  const [modalDelete, setmodalDelete] = useState(false);
  const [selectPrenotation, setselectPrenotation] = useState("");
  const [bookingId, setBookingId] = useState("");
  const [errorMessageModal, setErrorMessageModal] = useState("");
  const [attendanceSendInvitation, setAttendanceSendInvitation] = useState("");
  const [spinnerAttendanceSendInvitation, setSpinnerAttendanceSendInvitation] =
    useState(false);
  const { user } = useSelector((state: any) => state.login);

  let bookingSelected = prenotation.find(
    (item: any) => item.bookingId === bookingId
  );

  let eventId = _.get(bookingSelected, "timeslotObject.event");

  const dispatch = useAppDispatch();
  const deletePrenotation = (id: any, bookingId: string) => {
    setmodalDelete(true);
    setselectPrenotation(id);
    setBookingId(bookingId);
  };
  const deletePrenotationInStore = async () => {
    try {
      setmodalDelete(false);
      let result: any = {};

      if (hasModules(user, "FEDERFARMA_DOCTOR")) {
        result = await dispatch(
          deleteDoctorPrenotationStore(selectPrenotation)
        );
      } else {
        result = await dispatch(deletePrenotationStore(selectPrenotation));
      }

      // TODO: No UI difference in rendering success and error message... !?!?
      if (result.isError) {
        setErrorMessageModal(
          result?.data?.result?.message || result?.response?.data?.result?.message
        );
      } else {
        setErrorMessageModal(
          t("prenotation.delete-success")
        );
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  const getPrenotationInfo = () => {
    let prenotationInfo = { bookingId: "", name: "", surname: "" };
    if (selectPrenotation) {
      var prenotationSelect = prenotation.find(
        (p: any) => p._id === selectPrenotation
      );
      prenotationInfo.bookingId = prenotationSelect?.bookingId;
      prenotationInfo.name = prenotationSelect?.guest.name;
      prenotationInfo.surname = prenotationSelect?.guest.surname;
    }
    return prenotationInfo;
  };
  const sendInvitation = async (attendanceId: string) => {
    setSpinnerAttendanceSendInvitation(true);
    const result = await HttpService.post(
      `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/resendInvitation/${attendanceId}`,
      {}
    );
    setSpinnerAttendanceSendInvitation(false);
    setAttendanceSendInvitation("");
  };

  const openNoteBooking = (
    booking: string,
    attendanceFullName: string,
    eventId: string
  ) => {
    if (typeof props.openPopUpNote === "function") {
      props.openPopUpNote(booking, attendanceFullName, eventId);
    }
  };

  const getBadge = (value: any) => {
    const badge = getBadgeLabel(value?.bookingBy);
    const { label, color }: any = badge;
    return <TableCellTag label={label} color={color} />;
  };

  return (
    <>
      <tbody>
        {prenotation.map((value: any, key: number) => (
          <tr key={key}>
            <TableCell label={"#" + value?.bookingId} />
            <TableCellInformation name={value.guest.name} />
            <TableCell label={value.guest.surname} />
            <TableCell label={value.guest.email} />
            <TableCellDate data={value.timeslotyYearMonthDay} />
            <TableCellTime
              dataStart={value.timeslot?.startDate}
              dataEnd={value.timeslot?.endDate}
            />
            <TableCellTag
              label={value.timeslotcategories?.name}
              color={value.timeslotcategories?.color}
            />
            {getBadge(value)}

            <td className="text-right">
              <>
                <ButtonIcon
                  icon="sticky_note_2"
                  handleClick={() => {
                    openNoteBooking(
                      value?.bookingId,
                      `${value.guest.name} ${value.guest.surname}`,
                      value?.timeslotcategories?.event
                    );
                  }}
                />
                <ButtonIcon
                  icon="visibility"
                  handleClick={() => {
                    props?.openPopUpViewPrenotationByTimeslot(
                      value?.bookingId,
                      value?.timeslot,
                      value?.timeslotcategories?.event
                    );
                  }}
                />
                <ButtonIcon
                  icon="delete"
                  handleClick={() => {
                    deletePrenotation(value?._id, value?.bookingId);
                  }}
                />
                <DropdownIcon
                  dropdownItems={[
                    {
                      title: t("sendReservation"),
                      callback: () => {
                        setBookingId(value?.bookingId);
                        setAttendanceSendInvitation(value._id);
                        setSpinnerAttendanceSendInvitation(false);
                      },
                    },
                  ]}
                  icon="more_vert"
                />
              </>
            </td>
          </tr>
        ))}
      </tbody>
      <AlertMessageModal
        title={t("delete")}
        description={t("prenotation.label-delete", getPrenotationInfo())}
        closeModal={() => {
          setmodalDelete(false);
        }}
        titleButtonPrimary={t("delete")}
        handleClosePrimary={() => {
          deletePrenotationInStore();
        }}
        titleButtonSecondary={t("cancel")}
        handleCloseSecondary={() => {
          setmodalDelete(false);
        }}
        show={modalDelete}
      />
      <AlertMessageModal
        show={errorMessageModal !== ""}
        title={t("attention")}
        closeModal={() => setErrorMessageModal("")}
        description={errorMessageModal}
      />
      <AlertMessageModal
        title={t("attention")}
        description={t("popup-send-reservation.message")}
        closeModal={() => setAttendanceSendInvitation("")}
        titleButtonPrimary={t("popup-send-reservation.button-yes")}
        handleClosePrimary={() => {
          sendInvitation(attendanceSendInvitation);
        }}
        titleButtonSecondary={t("popup-send-reservation.button-no")}
        handleCloseSecondary={() => setAttendanceSendInvitation("")}
        spinnerButtonSecondary={spinnerAttendanceSendInvitation}
        show={attendanceSendInvitation != ""}
      />
    </>
  );
};

export default PrenotationRow;
